<section class="main-content wrapper content-padding">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a
          class="tab-link"
          routerLink="/sales/payments"
          routerLinkActive="active-tab"
          style="text-transform: uppercase;"
        >
          pagamenti delle vendite 
        </a>
      </label>
    </div>

    <div class="heading">
        <div class="button-wrapper">
            <button class="btn hvr-grow has-margin-right" routerLink="/all/vendita"> 
                <i class="ml-10 fas fa-arrow-left has-margin-right"></i>ALL VENDITA
            </button>
        </div>
    </div> 

    <section class="main-content wrapper content-padding scroll-delivery">
        <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
        <div class="table-responsive-invoice has-margin-top">
            <div class="custom-data-output has-margin-top" role="table" id="elencoConsegneAdmin">
                <form class="table-row-container row first-row filter" [formGroup]="customSalesFilterForm" (ngSubmit)="filter()" *ngIf="customSalesFilterForm">

                    <div class="item data-col-5">
                        <h4 class="title" (click)="navigateOrder('CustomPayment.id')">
                            <i class="sort-icon fas" [ngClass]="orderIcon('CustomPayment.id')"></i>
                            ID
                        </h4>
                        <span class="data">
                            <input type="number" formControlName="CustomPayment.id" min="1000" max="10000">
                        </span>
                    </div>        
                    
                    <div class="item data-col-5">
                        <h4 class="title">PLATFORM</h4>
                        <span class="data">
                            <select formControlName="CustomPayment.platform" style="width: 120px;">
                                <option value="">Tutti</option>
                                <option value="shopifysale">Deluxy</option>
                                <option value="cakesales">Cakes</option>
                                <option value="flowerssales">Flowers</option>
                                <option value="businesssales">Business</option>
                                <option value="deluxyexperiencesales">Deluxy Experience</option>
                                <option value="deluxydotcomsales">Deluxy Dot Com</option>
                            </select>
                        </span>
                    </div>

                    <div class="item data-col-5">
                        <h4 class="title" (click)="navigateOrder('ShopifySale.id')">
                            <i class="sort-icon fas" [ngClass]="orderIcon('ShopifySale.id')"></i>
                            SALE ID
                        </h4>
                        <span class="data">
                            <input type="number" formControlName="ShopifySale.id" min="1000" max="10000">
                        </span>
                    </div>                    

                    <div class="item data-col-5">
                        <h4 class="title" (click)="navigateOrder('CustomPayment.amount')">
                            <i class="sort-icon fas" [ngClass]="orderIcon('CustomPayment.amount')"></i>
                            AMOUNT
                        </h4>
                        <span class="data">
                            <input type="text" formControlName="CustomPayment.amount" >
                        </span>
                    </div>                    

                    <!--
                    <div class="item data-col-5">
                        <h4 class="title" (click)="navigateOrder('CustomPayment.currency')">
                            <i class="sort-icon fas" [ngClass]="orderIcon('CustomPayment.currency')"></i>
                            CURRENCY
                        </h4>
                        <span class="data">
                            <input type="text" formControlName="CustomPayment.currency" >
                        </span>
                    </div>                    
                    -->

                    <div class="item data-col-5">
                        <h4 class="title" (click)="navigateOrder('CustomPayment.paymentStatus')">
                            <i class="sort-icon fas" [ngClass]="orderIcon('CustomPayment.paymentStatus')"></i>
                            STATUS
                        </h4>
                        <span class="data">
                            <input type="text" formControlName="CustomPayment.paymentStatus" >
                        </span>
                    </div>                    
        
                    <div class="item nowrap">
                        <h4 class="title hide-on-mobile">AZIONI</h4>
                        <span class="data-row-left btn-container">
                        <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                            RICERCA <i class="fas fa-search"></i></button>
                            <br/>
                        <button class="btn vertical align-items-center" (click)="resetFliter();">
                            RESET <i class="fas fa-times-circle"></i></button>
                        </span>
                    </div>
                </form>

                <div class="table-row-container row" *ngFor="let payment of customSalePayments">

                    <div class="data-id item data-col-5">
                        <span class="data-row-left">
                            <h4 class="title table-title">ID :</h4>
                            <a >
                                #{{ payment.id }}
                            </a>
                        </span>
                    </div>                                   

                    <div class="item data-col-5">
                        <span class="data-row-left">
                            <h4 class="title table-title">PLATFORM :</h4>
                            <a >
                                {{ payment?.platform ? payment?.platform?.toUpperCase() : "---" }}
                            </a>
                        </span>
                    </div>                                   

                    <div class="item data-id data-col-5">
                        <span class="data-row-left">
                            <h4 class="title table-title">SALE ID :</h4>
                            <a >
                                #{{ getSaleId(payment) }}
                            </a>
                        </span>
                    </div>                                   

                    <div class="item data-col-5">
                        <span class="data-row-left">
                            <h4 class="title table-title">AMOUNT :</h4>
                            <a >
                                {{ payment?.amount || 0 | currency : "EUR" }}
                            </a>
                        </span>
                    </div>                                   

                    <!--
                    <div class="item data-col-5">
                        <span class="data-row-left">
                            <h4 class="title table-title">CURRENCY :</h4>
                            <a >
                                {{ payment.currency }}
                            </a>
                        </span>
                    </div>                                   
                    -->

                    <div class="item data-col-5">
                        <span class="data-row-left">
                            <h4 class="title table-title">STATUS :</h4>
                            <a >
                                <mat-chip [matTooltip]="showPaymentStatus(payment)" class="chip" [class]="salePaymentStatusClass(payment)">{{ showPaymentStatus(payment) }}</mat-chip>
                            </a>
                        </span>
                    </div>                   

                </div>
            </div>
        </div>
    </section>
  </div>
</section>